export enum CardTypesModel {
    VISA = "visa_card",
    MASTER_CARD = "master_card"
  }